import Vue from 'vue'
import Hot from 'vue-hotjar'
import GaAnalytics from "vue-analytics";

const isProd = process.env.NODE_ENV === 'production'

export default {
	setAnalyticTools(enabled) {

		if (enabled) {
			// configuration Google Analytics
			Vue.use(GaAnalytics, {
				// obecna GA od Kacka Kopackova / Zdenka Rybanska
				id: 'UA-116572432-4',
				checkDuplicatedScript: true,
				debug: {
					enabled: !isProd,
					sendHitTask: isProd
				}
			})

			// configure hotjar
			Vue.use(Hot, {
				// ID by melo byt pro kazdy projekt jiny
				id: '1970243',
				isProduction: isProd
			})
		} else {

			// provizorni inicializace
			// protoze v projektu je navazanych spousta eventu a generuje to errory do konzole
			Vue.use(GaAnalytics, {
				id: 'test',
				checkDuplicatedScript: true,
				disabled: true
			})
		}

	}
}
